import { render, staticRenderFns } from "./Upgrades.vue?vue&type=template&id=c92169f4&scoped=true"
import script from "./Upgrades.vue?vue&type=script&lang=js"
export * from "./Upgrades.vue?vue&type=script&lang=js"
import style0 from "./Upgrades.vue?vue&type=style&index=0&id=c92169f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92169f4",
  null
  
)

export default component.exports